"use client"

import Image from "next/image"
import { Card, CardContent } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { useLanguage } from "@/contexts/language-context"

interface ImageGalleryProps {
  fullGallery?: boolean
  onImageClick?: (prompt: string) => void
}

// 静态图库数据
const staticGalleryImages = [
  {
    id: "1",
    image_url: "/placeholder.svg?height=512&width=512",
    prompt: "futuristicCity",
    model: "Lunabrush v1",
  },
  {
    id: "2",
    image_url: "/placeholder.svg?height=512&width=384",
    prompt: "forestCabin",
    model: "Lunabrush Fantasy",
  },
  {
    id: "3",
    image_url: "/placeholder.svg?height=384&width=512",
    prompt: "spaceAstronaut",
    model: "Lunabrush v1",
  },
  {
    id: "4",
    image_url: "/placeholder.svg?height=512&width=512",
    prompt: "underwaterWorld",
    model: "Lunabrush v1",
  },
  {
    id: "5",
    image_url: "/placeholder.svg?height=512&width=384",
    prompt: "samurai",
    model: "Lunabrush Anime",
  },
  {
    id: "6",
    image_url: "/placeholder.svg?height=384&width=512",
    prompt: "mountainLake",
    model: "Lunabrush Realistic",
  },
  {
    id: "7",
    image_url: "/placeholder.svg?height=512&width=512",
    prompt: "spaceStation",
    model: "Lunabrush v1",
  },
  {
    id: "8",
    image_url: "/placeholder.svg?height=512&width=384",
    prompt: "magicForest",
    model: "Lunabrush Fantasy",
  },
]

export function ImageGallery({ fullGallery = false, onImageClick }: ImageGalleryProps) {
  const { t } = useLanguage()

  // 根据是否为完整画廊决定显示数量
  const displayImages = fullGallery ? staticGalleryImages : staticGalleryImages.slice(0, 8)

  const handleImageClick = (promptKey: string) => {
    if (onImageClick) {
      // 使用翻译后的提示词
      onImageClick(t(promptKey as any))
    }
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {displayImages.map((image, index) => (
          <div
            key={`${image.id}-${index}`}
            className="group cursor-pointer"
            onClick={() => handleImageClick(image.prompt)}
          >
            <Card className="overflow-hidden border-0 shadow-md transition-all hover:shadow-lg hover:scale-105">
              <CardContent className="p-0 relative">
                <div className="aspect-square relative overflow-hidden">
                  <Image
                    src={image.image_url || "/placeholder.svg"}
                    alt={t(image.prompt as any)}
                    fill
                    className="object-cover transition-transform group-hover:scale-105"
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 text-white opacity-0 transition-opacity group-hover:opacity-100">
                  <p className="text-xs line-clamp-2">{t(image.prompt as any)}</p>
                  <div className="flex justify-between items-center mt-1">
                    <Badge variant="outline" className="bg-black/30 text-white border-white/20 text-[10px]">
                      {image.model}
                    </Badge>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    </div>
  )
}
